import { render, staticRenderFns } from "./MemberSelector.vue?vue&type=template&id=5fdd7c10&scoped=true"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"
import style0 from "./MemberSelector.vue?vue&type=style&index=0&id=5fdd7c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd7c10",
  null
  
)

export default component.exports